import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import Companies from '@/pages/Companies'

export const Route = createFileRoute('/_authenticated/companies/')({
  validateSearch: listSearchSchema,
  component: Companies,
})
